import { render, staticRenderFns } from "./BinaryUploader.vue?vue&type=template&id=d5b4fc72&scoped=true&"
import script from "./BinaryUploader.vue?vue&type=script&lang=js&"
export * from "./BinaryUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b4fc72",
  null
  
)

export default component.exports